/**
 * Auto-generated RebelTech numeric game ID mapping
 * Source: rebeltech_games.json
 * Generated on: 2026-08-24T17:16:45.447Z
 * Total games: 667
 *
 * Do not edit by hand — run: npm run build:rebeltech-mapping
 */

export const rebeltechGameNameMapping = {
  "500465": "Monkey Warrior",
  "500466": "The Dog House",
  "500467": "Pirate Gold",
  "500468": "Great Rhino",
  "500469": "Panda's Fortune",
  "500470": "Buffalo King",
  "500471": "Pyramid King",
  "500472": "Ultra Burn",
  "500473": "Ultra Hold and Spin",
  "500474": "Joker King",
  "500475": "Return of the Dead",
  "500476": "Madame Destiny",
  "500477": "Diamond Strike",
  "500478": "Aztec King",
  "500479": "Wild Spells",
  "500480": "Big Bass Bonanza",
  "500481": "Cowboys Gold",
  "500482": "The Tiger Warrior",
  "500483": "Mustang Gold",
  "500484": "Hot Fiesta",
  "500485": "Dance Party",
  "500486": "Wild Wild Riches",
  "500487": "Hot to Burn Hold and Spin",
  "500488": "Empty the Bank",
  "500489": "The Hand of Midas",
  "500490": "Gates of Olympus",
  "500491": "Lucky Lightning",
  "500492": "Vegas Magic",
  "500493": "Fruit Party",
  "500494": "Fruit Party 2",
  "500495": "The Dog House Megaways",
  "500496": "Juicy Fruits",
  "500497": "Panda Fortune 2",
  "500498": "Buffalo King Megaways",
  "500499": "Wild West Gold",
  "500500": "Chicken Drop",
  "500501": "Spartan King",
  "500502": "Great Rhino Megaways",
  "500503": "Sweet Bonanza Xmas",
  "500504": "Extra Juicy",
  "500505": "Ancient Egypt",
  "500506": "Dragon Hot Hold and Spin",
  "500507": "Bigger Bass Bonanza",
  "500508": "The Tweety House",
  "500509": "5 Lions Megaways",
  "500510": "Rise of Samurai Megaways",
  "500511": "Pixie Wings",
  "500512": "Floating Dragon",
  "500513": "Sweet Bonanza",
  "500514": "Great Rhino Deluxe",
  "500515": "Madame Destiny Megaways",
  "500516": "Temujin Treasures",
  "500517": "Pirate Gold Deluxe",
  "500518": "Money Mouse",
  "500519": "Three Star Fortune",
  "500520": "Lucky Dragon Ball",
  "500521": "5 Lions Gold",
  "500522": "Ancient Egypt Classic",
  "500523": "Da Vinci's Treasure",
  "500524": "John Hunter and the Aztec Treasure",
  "500525": "Wolf Gold",
  "500526": "Safari King",
  "500527": "Peking Luck",
  "500528": "Asgard",
  "500529": "Vegas Nights",
  "500530": "John Hunter and the Tomb of the Scarab Queen",
  "500531": "Starlight Princess",
  "500532": "John Hunter and the Book of Tut",
  "500533": "Piggy Bank Bills",
  "500534": "8 Dragons",
  "500535": "5 Lions Dance",
  "500536": "Heart of Rio",
  "500537": "Rise of Giza PowerNudge",
  "500538": "Christmas Big Bass Bonanza",
  "500539": "Santa's Wonderland",
  "500540": "Bubble Pop",
  "500541": "Bounty Gold",
  "500542": "Hockey Attack",
  "500543": "Big Bass Bonanza Megaways",
  "500544": "Book of Fallen",
  "500545": "Big Juan",
  "500546": "John Hunter and the Quest for Bermuda Riches",
  "500547": "Star Pirates Code",
  "500548": "Mystic Chief",
  "500549": "Day of Dead",
  "500550": "Candy Village",
  "500551": "Wild Booster",
  "500552": "5 Lions",
  "500553": "Super 7s",
  "500554": "Master Joker",
  "500555": "Release the Kraken",
  "500556": "Fire Strike",
  "500557": "Caishen's Gold",
  "500558": "Aladdin and the Sorcerer",
  "500559": "Greek Gods",
  "500560": "Chilli Heat",
  "500561": "Magic Journey",
  "500562": "Leprechaun Carol",
  "500563": "7 Piggies",
  "500564": "Caishen's Cash",
  "500565": "Joker's Jewels",
  "500566": "Wild Gladiator",
  "500567": "Golden Pig",
  "500568": "Gold Rush",
  "500569": "Dragon Kingdom",
  "500570": "888 Dragons",
  "500571": "Aztec Gems",
  "500572": "Hercules and Pegasus",
  "500573": "Fire 88",
  "500574": "Honey Honey Honey",
  "500575": "Hot Safari",
  "500576": "Journey to the West",
  "500577": "The Great Chicken Escape",
  "500578": "Tree of Riches",
  "500579": "Wild Pixies",
  "500580": "Fairytale Fortune",
  "500581": "Santa",
  "500582": "Vampires VS Wolves",
  "500583": "3 Genie Wishes",
  "500584": "Hercules Son Of Zeus",
  "500585": "Aztec Bonanza",
  "500586": "Triple Dragons",
  "500587": "Lucky New Year",
  "500588": "Fruit Rainbow",
  "500589": "Mighty Kong",
  "500590": "Lady Godiva",
  "500591": "Monkey Madness",
  "500592": "Triple Tigers",
  "500593": "Master Chen's Fortune",
  "500594": "Hot to Burn",
  "500595": "Dwarven Gold Deluxe",
  "500596": "Great Reef",
  "500597": "Leprechaun Song",
  "500598": "7 Monkeys",
  "500599": "Lucky Dragons",
  "500600": "Treasure Horse",
  "500601": "Super Joker",
  "500602": "Egyptian Fortunes",
  "500603": "Hot Chilli",
  "500604": "Jurassic Giants",
  "500605": "Gold Train",
  "500606": "Beowulf",
  "500607": "Busy Bees",
  "500608": "Money Money Money",
  "500609": "Drago - Jewels of Fortune",
  "500610": "Fu Fu Fu",
  "500611": "Street Racer",
  "500612": "Aztec Gems Deluxe",
  "500613": "Jungle Gorilla",
  "500614": "Curse of the Werewolf Megaways",
  "500615": "Star Bounty",
  "500616": "Rise of Samurai",
  "500617": "Wild Walker",
  "500618": "Gems Bonanza",
  "500619": "Book of Kingdoms",
  "500620": "Fishin Reels",
  "500621": "The Dragon Tiger",
  "500622": "Christmas Carol Megaways",
  "500623": "John Hunter and the Mayan Gods",
  "500624": "Bonanza Gold",
  "500625": "Voodoo Magic",
  "500626": "Golden Ox",
  "500627": "Mysterious Egypt",
  "500628": "Emerald King Rainbow Road",
  "500629": "Eye of the Storm",
  "500630": "Starz Megaways",
  "500631": "Amazing Money Machine",
  "500632": "The Magic Cauldron",
  "500633": "Elemental Gems Megaways",
  "500634": "Chilli Heat Megaways",
  "500635": "Lucky Grace And Charm",
  "500636": "Aztec King Megaways",
  "500637": "Phoenix Forge",
  "500638": "Hokkaido Wolf",
  "500639": "Treasure Wild",
  "500640": "Raging Bull",
  "500641": "Cash Bonanza",
  "500642": "Pyramid Bonanza",
  "500643": "Emperor Caishen",
  "500644": "Lucky New Year - Tiger Treasures",
  "500645": "Fortune of Giza",
  "500646": "Gates of Valhalla",
  "500647": "Gold Party",
  "500648": "Extra Juicy Megaways",
  "500649": "Magician's Secrets",
  "500650": "Smugglers Cove",
  "500651": "Crystal Caverns Megaways",
  "500652": "Super X",
  "500653": "Rock Vegas",
  "500654": "Cash Patrol",
  "500655": "Colossal Cash Zone",
  "500656": "The Ultimate 5",
  "500657": "Wild Beach Party",
  "500658": "Book of Aztec King",
  "500659": "Might of Ra",
  "500660": "Bull Fiesta",
  "500661": "Rainbow Gold",
  "500662": "Tic Tac Take",
  "500663": "Disco Lady",
  "500664": "Queenie",
  "500665": "Barn Festival",
  "500666": "Chicken Chase",
  "500667": "Wild West Gold Megaways",
  "500668": "Clover Gold",
  "500669": "Drill that Gold",
  "500670": "Fire Strike 2",
  "500671": "Eye of Cleopatra",
  "500672": "Goblin Heist Powernudge",
  "500673": "The Great Stick-Up",
  "500674": "Zombie Carnival",
  "500675": "North Guardians",
  "500676": "Sugar Rush",
  "500677": "Cleocatra",
  "500678": "Little Gem",
  "500679": "Queen of Gods",
  "500680": "Koi Pond",
  "500681": "Rise Of Samurai III (Not Available for Japan)",
  "500682": "Cosmic Cash",
  "500683": "Bomb Bonanza",
  "500684": "Mahjong Panda",
  "500685": "Coffee Wild",
  "500686": "Shining Hot 100",
  "500687": "Shining Hot 20",
  "500688": "Shining Hot 40",
  "500689": "Shining Hot 5",
  "500690": "Tropical Tiki",
  "500691": "Cheeky Emperor",
  "500692": "Hot to Burn Extreme",
  "500693": "Gorilla Mayhem",
  "500694": "Octobeer Fortunes",
  "500695": "Big Bass Splash",
  "500696": "Fire Hot 100",
  "500697": "Fire Hot 20",
  "500698": "Fire Hot 40",
  "500699": "Fire Hot 5",
  "500700": "Greedy Wolf",
  "500701": "Down the Rails",
  "500702": "Magic Money Maze",
  "500703": "Floating Dragon Megaways Hold & Spin",
  "500704": "Wildman Super Bonanza",
  "500705": "Black Bull",
  "500706": "Candy Stars",
  "500707": "Crown of Fire",
  "500708": "Legend of Heroes Megaways",
  "500709": "Striking Hot 5",
  "500710": "Snakes & Ladders - Snake Eyes",
  "500711": "Book of Golden Sands",
  "500712": "Wild Hop & Drop",
  "500713": "Sword of Ares",
  "500714": "Spin & Score Megaways",
  "500715": "Santa's Great Gifts™",
  "500716": "Bigger Bass Blizzard - Christmas Catch",
  "500717": "Kingdom of Asgard",
  "500718": "Firebird Spirit",
  "500719": "Starlight Christmas",
  "500720": "Gates of Gatot Kaca",
  "500721": "Gems of Serengeti",
  "500722": "Shield of Sparta",
  "500723": "Big Bass Bonanza Keeping it Reel",
  "500724": "Lucky Fishing Megaways",
  "500725": "5 Rabbits Megaways",
  "500726": "Pizza！Pizza？Pizza！",
  "500727": "Gates of Aztec",
  "500728": "Hot Pepper",
  "500729": "Sweet Powernudge",
  "500730": "Fury of Odin Megaways",
  "500731": "Viking Forge",
  "500732": "Twilight Princess",
  "500733": "Grace of Ebisu",
  "500734": "Starlight Princess 1000",
  "500735": "The Money Men Megaways",
  "500736": "888 Bonanza",
  "500737": "Demon Pots",
  "500738": "John Hunter and the Book of Tut Megaways",
  "500739": "8 Golden Dragon Challenge",
  "500740": "Yi Sun Shin",
  "500741": "Candy Blitz",
  "500742": "Fortunes of Aztec",
  "500743": "Infective Wild",
  "500744": "Gravity Bonanza",
  "500745": "Rainbow Reels",
  "500746": "Sweet Bonanza Dice",
  "500747": "Big Bass Halloween",
  "500748": "Tundra’s Fortune",
  "500749": "Cash Chips",
  "500750": "Gemstone",
  "500751": "Mahjong Wins",
  "500752": "Wisdom of Athena",
  "500753": "Forge of Olympus",
  "500754": "Zeus vs Hades - Gods of War",
  "500755": "Big Bass Hold & Spinner Megaways",
  "500756": "Cyclops Smash",
  "500757": "Saiyan Mania",
  "500758": "Piggy Bankers",
  "500759": "Pub Kings",
  "500760": "Mustang Trail",
  "500761": "Supermania",
  "500762": "Diamond Cascade",
  "500763": "Lobster Bob's Crazy Crab Shack",
  "500764": "3 Buzzing Wilds",
  "500765": "The Dog House Multihold",
  "500766": "Spellbinding Mystery",
  "500767": "Cash Box",
  "500768": "Kraken's Sky Bounty",
  "500769": "Hellvis Wild",
  "500770": "Joker Race",
  "500771": "Big Bass Amazon Xtreme",
  "500772": "Heist for the Golden Nuggets",
  "500773": "Fat Panda",
  "500774": "Jewel Rush",
  "500775": "Pirates Pub",
  "500776": "Frogs & Bugs",
  "500777": "Lamp Of Infinity",
  "500778": "Robber Strike",
  "500779": "Floating Dragon - Dragon Boat Festival",
  "500780": "Sticky Bees",
  "500781": "Knight Hot Spotz",
  "500782": "Excalibur Unleashed",
  "500783": "Wild Bison Charge",
  "500784": "Holiday Ride",
  "500785": "Jasmine Dreams",
  "500786": "Kingdom of The Dead",
  "500787": "Cowboy Coins",
  "500788": "Gods of Giza",
  "500789": "Wild Celebrity Bus Megaways",
  "500790": "3 Dancing Monkeys",
  "500791": "African Elephant",
  "500792": "Big Bass Bonanza - Hold & Spinner",
  "500793": "Moonshot",
  "500794": "The Red Queen",
  "500795": "Fruits of the Amazon",
  "500796": "The Knight King",
  "500797": "Rabbit Garden",
  "500798": "Mystery Of The Orient",
  "500799": "Peak Power",
  "500800": "Club Tropicana",
  "500801": "Fire Archer",
  "500802": "Gatot Kaca's Fury",
  "500803": "Mochimon",
  "500804": "Fish Eye",
  "500805": "Monster Superlanche",
  "500806": "Frozen Tropics",
  "500807": "Gold Oasis",
  "500808": "Secret City Gold",
  "500809": "Mammoth Gold Megaways",
  "500810": "Wild Wild Bananas",
  "500811": "Rujak Bonanza",
  "500812": "Joker Jewels Dice",
  "500813": "Big Bass Christmas Bash",
  "500814": "Mahjong X",
  "500815": "Sugar Rush Xmas",
  "500816": "5 Frozen Charms Megaways",
  "500817": "Ding Dong Christmas Bells",
  "500818": "The Dog House Dice Show",
  "500819": "Gates of Olympus 1000",
  "500820": "Floating Dragon New Year Festival Megaways",
  "500821": "Fortune Dragon",
  "500822": "Mahjong Wins Bonus",
  "500823": "Fortune Ace",
  "500824": "Bali Dragon",
  "500825": "Gates of Olympus Dice",
  "500826": "Power of Ninja",
  "500827": "Zombie Train",
  "500828": "Casino Heist Megaways",
  "500829": "Gates of Gatot Kaca 1000",
  "500830": "Big Bass Day at the Races",
  "500831": "Sugar Rush 1000",
  "500832": "Rise of Samurai 4",
  "500833": "Cyber Heist",
  "500834": "Fire Portals",
  "500835": "The Dog House Dog or Alive",
  "500836": "Big Bass Secrets of the Golden Lake",
  "500837": "Joker's Jewels Wild",
  "500838": "Starlight Princess Pachi",
  "500839": "Sweet Bonanza 1000",
  "500840": "Big Bass Mission Fishin’",
  "500841": "Buffalo King Untamed Megaways",
  "500842": "Hot to Burn Multiplier",
  "500843": "Hand of Midas 2",
  "500844": "Sweet Kingdom",
  "500845": "Crank It Up",
  "500846": "Samurai Code",
  "500847": "Dynamite Diggin Doug",
  "500848": "Joker’s Jewels Hot",
  "500849": "Jackpot Hunter",
  "500850": "Bow of Artemis",
  "500851": "Money Stacks",
  "500852": "Dragon Gold 88",
  "500853": "Running Sushi",
  "500854": "Yeti Quest",
  "500855": "Big Bass Vegas Double Down Deluxe",
  "500856": "Wisdom of Athena 1000",
  "500857": "888 Gold",
  "500858": "Big Bass Halloween 2",
  "500859": "Mahjong Wins 3 – Black Scatter",
  "500860": "River of Styx",
  "500861": "Barbar",
  "500862": "Cappadocia",
  "500863": "Thunder vs Underworld",
  "500864": "Mr Tain's Fury: Wild Wild Gladiator",
  "500865": "Strike Frenzy",
  "500866": "Trolling 1000",
  "500867": "Gold Carp Bonanza",
  "500868": "Games in Olympus",
  "500869": "Devil Joker",
  "500870": "Gates of LeoVegas 1000",
  "500871": "Mahjong Wins 2",
  "500872": "Mafiosa - Dead or a Llama",
  "500873": "Puffers vs Sharks",
  "500874": "Sugar Rush Dice",
  "500875": "The Green Sun",
  "500876": "Book of Vikings",
  "500877": "Big Bass Xmas Xtreme",
  "500878": "Penguins Christmas Party Time",
  "500879": "Santa’s Xmas Rush",
  "500880": "Jajanan Pasar",
  "500881": "Pirate Quest 1000",
  "500882": "Mighty Hercules",
  "500883": "Gates of Olympus Xmas 1000",
  "500884": "Old Gold Miner Megaways",
  "500885": "Laughing Fortune",
  "500886": "Monkey King Rush",
  "500887": "Floating Dragon Year of the Snake",
  "500888": "Mahjong Wins - Gong Xi Fa Cai",
  "500889": "Bigger Bass Splash",
  "500890": "Big Bass Return to the Races",
  "500891": "Gates of Olympus 1000 Dice",
  "500892": "Sweet Bonanza 1000 Dice",
  "500893": "Big Bass Dice",
  "500894": "The Dog House – Royal Hunt",
  "500895": "Gates of Olympus Super Scatter",
  "500896": "Mahjong Wins Super Scatter",
  "500897": "Big Bass Boxing Bonus Round",
  "500898": "Temple Guardians",
  "500899": "Gold Party 2-After Hours",
  "500900": "Finger Lick’n Free Spins",
  "500901": "Gem Fire Fortune",
  "500902": "Gem Trio",
  "500903": "Chilli Heat Spicy Spins",
  "500904": "You Can Piggy Bank On It",
  "500905": "Alien Invaders",
  "500906": "Club Tropicana – Happy Hour",
  "500907": "Waves of Poseidon",
  "500908": "Sweet Bonanza Super Scatter",
  "500909": "Wolf Gold 4 Pack",
  "500910": "Argonauts",
  "500911": "Zombie School Megaways",
  "500912": "Ice Mints",
  "500913": "Big Bass Reel Repeat",
  "500914": "Spellmaster",
  "500915": "Jackpot Blaze",
  "500916": "Fire Stampede 2",
  "500919": "AUTO Roulette",
  "500920": "Speed AUTO Roulette",
  "500921": "Roulette 3",
  "500922": "Speed Roulette 1",
  "500923": "Roulette 1",
  "500924": "Turkish Roulette",
  "500925": "Speed Roulette 2",
  "500926": "Romanian Roulette",
  "500927": "Roulette Latina",
  "500928": "German Roulette",
  "500929": "Russian Roulette",
  "500930": "Roulette Italia Tricolore",
  "500931": "Roulette Macao",
  "500932": "Speed Baccarat 6",
  "500933": "Speed Baccarat 5",
  "500934": "Baccarat 2",
  "500937": "Baccarat 7",
  "500938": "Turbo Baccarat",
  "500939": "Speed Baccarat 15",
  "500940": "Speed Baccarat 10",
  "500941": "Speed Baccarat 9",
  "500942": "Speed Baccarat 7",
  "500943": "Speed Baccarat 8",
  "500944": "Super 8 Baccarat",
  "500945": "Fortune 6 Baccarat",
  "500946": "Baccarat 9",
  "500947": "Speed Baccarat 12",
  "500948": "Baccarat 3",
  "500949": "Speed Baccarat 11",
  "500950": "Baccarat 1",
  "500951": "Speed Baccarat 2",
  "500952": "Speed Baccarat 13",
  "500954": "Baccarat 5",
  "500955": "Baccarat 6",
  "500956": "Speed Baccarat 1",
  "500957": "Speed Baccarat 3",
  "500958": "MEGA SIC BO",
  "500959": "Sicbo",
  "500960": "MEGA Wheel",
  "500964": "Aztec Blaze",
  "500965": "Towering Fortunes",
  "500966": "Pirate Golden Age",
  "500967": "Reel Banks",
  "500968": "Diamonds of Egypt",
  "500969": "Jane Hunter and the Mask of Montezuma",
  "500970": "Sugar Supreme Powernudge",
  "500971": "Timber Stacks",
  "500972": "Nile Fortunes",
  "500973": "Fire Stampede",
  "500974": "The Wild Gang",
  "500975": "Juicy Fruits Multihold",
  "500976": "Castle of Fire",
  "500977": "Good Luck & Good Fortune",
  "500978": "Blade & Fangs",
  "500979": "The Big Dawgs",
  "500980": "Loki's Riches",
  "500981": "Blazing Wilds Megaways",
  "500982": "Trees of Treasure",
  "500983": "The Alter Ego",
  "500984": "Big Bass Floats My Boat",
  "500985": "Wheel O’Gold",
  "500986": "Pompeii Megareels Megaways",
  "500987": "Strawberry Cocktail",
  "500988": "Mighty Munching Melons",
  "500989": "Gears of Horus",
  "500990": "Pot of Fortune",
  "500991": "Big Burger Load it up with Xtra Cheese",
  "500992": "Aztec Powernudge",
  "500993": "Release the Bison",
  "500994": "Ripe Rewards",
  "500995": "Barnyard Megahays Megaways",
  "500996": "Ice Lobster",
  "500997": "Candy Blitz Bombs",
  "500998": "Heroic Spin",
  "500999": "Heart of Cleopatra",
  "501000": "Odds On Winner",
  "501001": "Dwarf & Dragon",
  "501002": "Rise of Pyramids",
  "501003": "Devilicious",
  "501004": "Medusa’s Stone",
  "501005": "Sumo Supreme Megaways",
  "501006": "Forging Wilds",
  "501007": "Hot to Burn – 7 Deadly Free Spins",
  "501008": "Aztec Treasure Hunt",
  "501009": "Gem Elevator",
  "501010": "Angel vs Sinner",
  "501011": "Congo Cash XL",
  "501012": "Oodles of Noodles",
  "501013": "Mystery Mice",
  "501014": "Badge Blitz",
  "501015": "The Dog House – Muttley Crew",
  "501016": "Fortune Hit'n Roll",
  "501017": "7 Clovers of Fortune",
  "501018": "Candy Corner",
  "501019": "Moleionaire",
  "501020": "Wolf Gold Ultimate",
  "501021": "Himalayan Wild",
  "501022": "Eternal Empress – Freeze Time",
  "501023": "Might of Freya Megaways",
  "501024": "Mining Rush",
  "501025": "Big Bass Bonanza 3 Reeler",
  "501026": "Dragon King Hot Pots",
  "501027": "Aztec Smash",
  "501028": "Fonzo’s Feline Fortunes",
  "501029": "Brick House Bonanza",
  "501030": "Aztec Gems Megaways™",
  "501031": "Wild Wild Pearls",
  "501032": "Irish Crown",
  "501033": "Wild Wildebeest Wins",
  "501034": "Escape the Pyramid – Fire & Ice",
  "501035": "Ancient Island Megaways™",
  "501036": "Greedy Fortune Pig",
  "501037": "Savannah Legend",
  "501038": "Peppe’s Pepperoni Pizza Plaza",
  "501039": "Raging Waterfall Megaways™",
  "501040": "Wild Wild Joker",
  "501041": "Blitz Super Wheel",
  "501042": "Bandit Megaways™",
  "501043": "Ride The Lightning",
  "501044": "Big Bass Bonanza 1000",
  "501045": "Resurrecting Riches",
  "501046": "Witch Heart Megaways",
  "501047": "Sleeping Dragon",
  "501048": "Fiesta Fortune",
  "501049": "Gates of Hades",
  "501050": "Majestic Express-Gold Run",
  "501051": "Eye of Spartacus",
  "501052": "Wild West Gold Blazing Bounty",
  "501053": "Captain Kraken Megaways",
  "501054": "Lobster House",
  "501055": "Genie’s Gem Bonanza",
  "501056": "Bee Keeper",
  "501057": "Bounty Hunter",
  "501058": "Hundreds and Thousands",
  "501059": "Fortune Ace Super Scatter",
  "501060": "Bigger Barn House Bonanza",
  "501061": "Mermaid’s Treasure Trove",
  "501062": "Big Bass Halloween 3",
  "501063": "Lava Balls",
  "501064": "Bingo Mania",
  "501065": "Frightening Frankie",
  "501066": "Starlight Princess Super Scatter",
  "501067": "Big Bass Christmas Frozen Lake",
  "502763": "Roulette Lobby",
  "502764": "Baccarat & Sicbo Lobby",
  "502765": "Game Shows Lobby",
  "502766": "Top Games Lobby",
  "502767": "Roulette",
  "502768": "American Roulette",
  "502769": "Lightning Roulette",
  "502770": "Double Ball Roulette",
  "502771": "Immersive Roulette",
  "502772": "Auto-Roulette VIP",
  "502773": "Auto-Roulette",
  "502774": "Speed Roulette",
  "502775": "Grand Casino Roulette",
  "502776": "Casino Malta Roulette",
  "502777": "Dragonara Roulette",
  "502778": "Speed Auto Roulette",
  "502779": "VIP Roulette",
  "502780": "Baccarat A",
  "502781": "Baccarat B",
  "502782": "Speed Baccarat A",
  "502783": "Speed Baccarat B",
  "502784": "Speed Baccarat C",
  "502785": "Speed Baccarat D",
  "502786": "Speed Baccarat E",
  "502787": "Speed Baccarat F",
  "502788": "Speed Baccarat G",
  "502789": "Speed Baccarat H",
  "502790": "Speed Baccarat I",
  "502791": "Speed Baccarat J",
  "502792": "Speed Baccarat L",
  "502793": "Speed Baccarat N",
  "502794": "Speed Baccarat Q",
  "502795": "Speed Baccarat R",
  "502796": "Speed Baccarat S",
  "502797": "Speed Baccarat T",
  "502798": "Speed Baccarat U",
  "502799": "Speed Baccarat V",
  "502800": "Speed Baccarat W",
  "502801": "Speed Baccarat X",
  "502802": "Speed Baccarat Z",
  "502803": "Speed Baccarat 1",
  "502804": "Speed Baccarat 2",
  "502805": "Speed Baccarat 3",
  "502806": "Speed Baccarat 4",
  "502807": "No Commission Baccarat",
  "502808": "Golden Wealth Baccarat",
  "502809": "Crazy Time",
  "502810": "Crazy Time A",
  "502811": "Lightning Dice",
  "502812": "Dream Catcher",
  "502813": "Super Sic Bo",
  "502814": "Speed Super Sic Bo",
  "502815": "Lightning Roulette Italia",
  "502816": "Dynasty Lightning Roulette",
  "502817": "Dynasty Roulette",
  "506186": "Hot Tuna",
  "506187": "Big Bass Splash 1000",
  "506188": "DJ Neko",
  "506189": "Santa’s Slay",
  "506190": "Gates of Gatot Kaca Super Scatter",
  "506191": "Gates of Pyroth",
  "506192": "Joker’s Jewels Hold & Spin",
  "506193": "Lucky Fortune Tree",
  "506194": "Super Gummy Strike",
  "506195": "Anaconda Gold",
  "506196": "Wheel of Happiness",
  "506197": "Dragon Tiger Fortunes",
  "506198": "Hotpot Wins",
  "506199": "King of Spear",
  "506200": "Starlight Archer 1000",
  "506201": "BigBoy Rush 1000",
  "506202": "Gates of Sneaker Super Scatter"
};

export default rebeltechGameNameMapping;
